import { BatchHttpLink } from '@apollo/client/link/batch-http';
import { HttpLink, from } from '@apollo/client';
import { featureFlagClient } from '@trello/feature-flag-client';
import { trelloRequiredHeadersLink } from './trelloRequiredHeadersLink';

// We export this function mostly to help with testing.
export function createTrelloHttpLink() {
  return from([
    trelloRequiredHeadersLink,
    featureFlagClient.get('fep.use-batched-graphql-queries', true)
      ? // eslint-disable-next-line @trello/no-module-logic
        new BatchHttpLink({
          // Wait no more than 10ms after first batched operation
          batchInterval: 10,
          // No more than 10 operations per batch
          batchMax: 10,
          credentials: 'include',
        })
      : // eslint-disable-next-line @trello/no-module-logic
        new HttpLink({
          credentials: 'include',
          uri: (operation) => {
            const operationNamesEnabled = featureFlagClient.get(
              'fep.operation-name-in-url',
              false,
            );

            // We include the "operationName" parameter purely for debugging. This should never infer behavior or be relied
            // upon by the server.
            return !operationNamesEnabled || !operation.operationName
              ? '/graphql'
              : `/graphql?operationName=${operation.operationName}`;
          },
        }),
  ]);
}
